import { render, staticRenderFns } from "./ShareEvent.vue?vue&type=template&id=6f4278f2&"
import script from "./ShareEvent.vue?vue&type=script&lang=js&"
export * from "./ShareEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports